<template>
  <div id="app" style="background: #f3f6fb">
    <!-- 顶部 -->
    <div class="topbj">
      <img src="./assets/img/topTitle.gif" v-if="windowWidth < 769" style="
          width: 80%;
          position: absolute;
          top: calc((100% - 160px) / 2);
          max-height: 195px;
          left: 10%;
        " />
      <div class="search-position">
        <!-- 功能导航 -->
        <topNavigation fontColor="#fff" fontSize="13px" fontFamily="" topHeight="40px" homeWidth="1200px"
          :deleteSort="[6]" navBodyBackground="none">
          <template slot="nav-top-content-r">
            <li class="fl">
              <!-- color优先数组内的color 其次是父组件的fontcolor 最后是组件内的color -->
              <router-link :to="{
                path: '/introduce',
              }" style="color: #fff">产品与服务</router-link>
            </li>
            <li class="fl" :style="{
              background:
                ' url(' +
                require('./assets/img/new.png') +
                ') no-repeat right center',
              width: '90px',
            }">
              <!-- color优先数组内的color 其次是父组件的fontcolor 最后是组件内的color -->
              <!-- href="http://misc.drcnet.com.cn/help/emerging/guide.mp4" -->
              <a href="https://www.drcnet.com.cn/bayWindow/ProjectMV?title=战略性新兴产业及未来产业数据库平台&url=https://misc.drcnet.com.cn/help/emerging/emerging-guide.mp4"
                target="_blank" style="color: #fff">视频介绍</a>
            </li>
          </template>
          <template slot="nav-top-content-isMobile-bottom">
            <!-- m_上方导航 -->
            <ul class="ul1">
              <template v-for="(item, index) in nav">
                <li :key="index" v-if="index < 13 && index != 0 && index != 1">
                  <router-link :to="{
                    path: '/list',
                    query: { uid: item.uid, text: item.text },
                  }" class="navtxt">{{ item.text }}</router-link>
                </li>
                <li :key="index" v-if="index == 0">
                  <router-link to="/" class="navtxt navon">{{
                    item.text
                    }}</router-link>
                </li>
              </template>
              <template v-for="(item, index) in nav">
                <li :key="index" v-if="index >= 13 && index <= 19 && index != 13">
                  <router-link :to="{
                    path: '/list',
                    query: { uid: item.uid, text: item.text },
                  }" class="navtxt">
                    {{ item.text }}
                  </router-link>
                </li>
                <li :key="index" v-if="index == 13" class="border_l">
                  <router-link :to="{
                    path: '/list',
                    query: { uid: item.uid, text: item.text },
                  }" class="navtxt">
                    {{ item.text }}
                  </router-link>
                </li>
              </template>
            </ul>
          </template>
        </topNavigation>
        <Search class="add" searchPosition="1" selectType="1,3,0" keyWordsInputTab="请输入关键词" searchUrl="4,4797,27"
          heighSearchUrl="2,16874" searchBoxWidth="440,0" searchInputWidth="206,0" inputAndSelectWrapWidth="281,0"
          :simpleSearchIcon="require('./assets/img/search_a.png')" simpleSearchButton="35,20,#0970d2,8,12"
          heighSearchButton="35,20,#606e82,8,12">
          <template v-slot:aiBtn>
            <!-- 你想要放的自定义按钮 -->
            <a @click="searchGoAi()" target="blank" class="searchbtnb aibtnb">AI检索</a>
          </template>
        </Search>
      </div>
    </div>
    <!-- 上方导航 -->
    <div class="nav">
      <div class="home">
        <ul class="fl ul1">
          <template v-for="(item, index) in nav">
            <li :key="index" v-if="index < 13 && index != 0 && index != 1 && item.uid != 2723">
              <router-link :to="{
                path: '/list',
                query: { uid: item.uid, text: item.text },
              }" class="navtxt">{{ item.text }}</router-link>
            </li>
            <li :key="index" v-if="index == 0">
              <router-link to="/" class="navtxt navon">{{
                item.text
                }}</router-link>
            </li>
            <li :key="index" id="SubNav2723" v-if="item.uid == 2723" style="float: none">
              <router-link :to="{
                path: '/list',
                query: { uid: item.uid, text: item.text },
              }" class="navtxt navon">{{ item.text }}</router-link>
              <template v-for="childItem in item.children">
                <span v-if="!childItem.isnav" :key="childItem.uid">
                  <router-link :to="{
                    path: '/list',
                    query: { uid: childItem.uid, text: childItem.text },
                  }" class="navtxt">
                    {{ childItem.text }}
                  </router-link>
                </span>
              </template>
            </li>
          </template>
        </ul>
        <div class="clear"></div>
      </div>
    </div>
    <!-- 下方导航 -->
    <div class="nav2">
      <div class="home">
        <ul class="fl ul2">
          <template v-for="(item, index) in nav">
            <li :key="index" v-if="
              index >= 13 &&
              index <= 19 &&
              index != 13 &&
              index != 19 &&
              item.uid != '2725'
            ">
              <router-link :to="{
                path: '/list',
                query: { uid: item.uid, text: item.text },
              }" class="navtxt">
                {{ item.text }}
              </router-link>
            </li>
            <li :key="index" v-if="index == 13" class="border_l">
              <router-link :to="{
                path: '/list',
                query: { uid: item.uid, text: item.text },
              }" class="navtxt">
                {{ item.text }}
              </router-link>
            </li>
            <li :key="index" v-if="index == 19" class="border_l">
              <a href="http://company.drcnet.com.cn/ktyj.html#/product_service/research?param=%E6%94%BF%E7%AD%96%E8%A7%84%E5%88%92%E5%92%A8%E8%AF%A2"
                class="navtxt">
                {{ item.text }}
              </a>
            </li>
            <li :key="index" v-if="item.uid == '2725'" class="border_l">
              <router-link :to="{
                path: '/list',
                query: { uid: '272106', text: item.text },
              }" class="navtxt">
                {{ item.text }}
              </router-link>
            </li>
          </template>
        </ul>
        <div class="clear"></div>
      </div>
    </div>
    <router-view></router-view>
    <!-- 返回顶部 -->
    <div class="scroll-top" @click="returnTop()" style="display: block" v-show="showBackToTop">
      <div class="btn-top"></div>
    </div>
    <!-- footer -->
    <Footer></Footer>
  </div>
</template>
<script>
import topNavigation from "@/components/topNavigation.vue";
import TopBanner from "@/components/TopBanner";
import Search from "@/components/Search";
import Footer from "./components/Footer/index.vue";
import { getNav } from "./require/api";
export default {
  name: "index",
  components: {
    topNavigation,
    TopBanner,
    Search,
    Footer,
  },
  data() {
    return {
      nav: [],
      scrollY: 0, // 当前滚动距离
      showBackToTop: false, // 是否显示返回顶部按钮
      threshold: 300, // px 滚动距离阈值
    };
  },
  created() {
    this.getNavData();
    window.addEventListener("scroll", this.handleScroll);
  },
  computed: {
    // 计算属性，返回当前是否应该显示返回顶部按钮
    shouldShowBackToTop() {
      return this.scrollY >= this.threshold; // 假设滚动距离超过 500px 时显示按钮
    },
  },

  methods: {
    searchGoAi() {
      window.open('https://search.drcnet.com.cn/aiSearch'); // 弹出一个新页面
    },
    async getNavData() {
      const { data } = await getNav({ uid: 27 });
      if (data.code == 0) {
        // console.log(data);
        this.nav = data.data.data.children;
        this.$eventBus.$emit("nav", this.nav);
        this.$store.commit('setNavs', this.nav);
      }
    },
    returnTop() {
      window.scrollTo({ top: 0, behavior: "smooth" }); // 平滑滚动至顶部
      // 如果不想使用平滑滚动效果，也可以直接调用下面这行代码
      // window.scrollTo(0, 0);
    },
    handleScroll() {
      this.scrollY = window.scrollY;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
  watch: {
    // 监听 scrollY 属性的变化，更新 showBackToTop 属性
    scrollY(newValue) {
      this.showBackToTop = this.shouldShowBackToTop;
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .toplogin {
  background: none !important;
  border-bottom: none !important;
}

#app {
  transition: all 0.1s ease;
  /* 所有属性都会产生1秒的平滑过渡效果 */
}

.topbj {
  background: url(./assets/img/topheader.gif) no-repeat top;
  height: 375px;

  .search-position {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    position: relative;

    .searchbox {
      top: 300px;
    }
  }
}

.nav {
  height: 78px;
  line-height: 45px;
  background: #004ea1;

  .home {
    width: 1200px;
    margin: 0 auto;

    .fl {
      float: left;
    }

    .clear {
      clear: both;
    }

    .ul1 {
      li {
        float: left;
        font-size: 15px;

        a {
          color: #fff;
          font-size: 15px;
        }

        .navon {
          color: #ffe400 !important;
        }

        &+li {
          // padding-left: 12px;
          padding-left: 25px;
        }
      }
    }
  }
}

.nav2 {
  height: 40px;
  line-height: 40px;
  background: #dbe6f2;

  .home {
    width: 1200px;
    margin: 0 auto;

    .ul2 {
      li {
        width: 160px;
        border-right: 1px solid #a6c3e3;
        text-align: center;
        float: left;
        font-size: 15px;

        a {
          color: #0f243c;
          width: 160px;
          display: block;
        }
      }

      .border_l {
        border-left: 1px solid #a6c3e3;
      }
    }

    .fl {
      float: left;
    }

    .clear {
      clear: both;
    }
  }
}

.scroll-top {
  display: none;
  position: fixed;
  right: 0;
  margin-right: 20px;
  bottom: 20px;
  padding-bottom: 20px;
  z-index: 999;
  width: 47px;
  height: 47px;

  .btn-top {
    background: url(./assets/img/Back1.png) no-repeat center;
    width: 47px;
    height: 47px;

    &:hover {
      background: url(./assets/img/Back2.png) no-repeat center;
    }
  }
}

#SubNav2723 {
  text-align: center;
  line-height: 16px;

  span {
    margin: 0 16px;
  }
}

.aibtnb {
  background: rgb(184, 134, 11) !important;
  height: 35px;
  line-height: 35px;
  padding: 0 8px;
  margin-left: 1px;
}

::v-deep .searchbox {
  width: 470px !important;
}

@media screen and (max-width: 769px) {
  .search-position {
    width: 100% !important;
  }

  .home {
    width: 100% !important;
  }

  .nav,
  .nav2 {
    display: none !important;
  }

  .ul1 {
    padding: 16px;

    li {
      border-bottom: 1px dashed #888;
      padding: 8px 0;

      a {
        color: #333;
        line-height: 160%;
      }
    }
  }

  .topbj {
    background: url(./assets/img/topheader.png) no-repeat top !important;
    background-size: 100% 100% !important;
    height: 375px;
    position: relative;
  }

  ::v-deep .searchbox {
    width: auto !important;

    .search {
      width: calc(100% - 188px) !important;
    }
  }
}
</style>
